import { useCallback } from 'react';

export interface UseKeyboardHandlersDeps {
  undo: () => void;
  redo: () => void;
  setSelectedBlockId: (id: string | null) => void;
  setSelectedGroupId: (id: string | null) => void;
  setConnectMode: (v: boolean) => void;
  setGroupMode: (v: boolean) => void;
  setGroupSelection: (ids: string[]) => void;
  logAction: (action: string, detail?: string) => void;
  announce: (msg: string) => void;
}

export function useKeyboardHandlers(deps: UseKeyboardHandlersDeps) {
  const {
    undo, redo,
    setSelectedBlockId, setSelectedGroupId,
    setConnectMode, setGroupMode, setGroupSelection,
    logAction, announce,
  } = deps;

  const handleUndo = useCallback(() => {
    undo();
    logAction('Undo');
    announce('Undo');
  }, [undo, logAction, announce]);

  const handleRedo = useCallback(() => {
    redo();
    logAction('Redo');
    announce('Redo');
  }, [redo, logAction, announce]);

  const handleEscape = useCallback(() => {
    setSelectedBlockId(null);
    setSelectedGroupId(null);
    setConnectMode(false);
    setGroupMode(false);
    setGroupSelection([]);
  }, [setSelectedBlockId, setSelectedGroupId, setConnectMode, setGroupMode, setGroupSelection]);

  return { handleUndo, handleRedo, handleEscape };
}
